import { AccountArrowLeftIcon } from './AccountArrowLeftIcon';

/**
 * author: Coffeemate
 * id 34EAE057-F0E4-476A-B988-9BD149263BDF
 * name account-arrow-left
 * version: 3.0.39
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/account-arrow-left.svg
 * tags
 * - Account / User 
 */
export const PersonArrowLeftIcon = AccountArrowLeftIcon;
export default PersonArrowLeftIcon